import { Link } from 'react-router-dom'
import { useSync } from '../sync/useSync'
import { sincronizar } from '../sync/sincronizador'
import { rotuloDaBarra, type CorDaBarra } from '../sync/rotuloDaBarra'

const CLASSE_DA_COR: Record<CorDaBarra, string> = {
  verde: 'bg-emerald-400',
  ambar: 'bg-amber-400',
  vermelho: 'bg-red-400',
}

export default function BarraSync() {
  const { estado, pendencias, travados } = useSync()
  const { cor, texto } = rotuloDaBarra(estado, pendencias, travados)

  // O "ver" e IRMAO do botao, nunca filho: botao dentro de botao e HTML
  // invalido e quebraria o clique em barra-sync, do qual todo E2E depende.
  return (
    <div className="flex items-center gap-2 text-xs text-white/90">
      <button
        data-testid="barra-sync"
        onClick={() => void sincronizar()}
        className="flex items-center gap-2"
        title="Toque para sincronizar agora"
      >
        <span className={`inline-block w-2 h-2 rounded-full ${CLASSE_DA_COR[cor]}`} />
        {texto}
      </button>
      {travados > 0 && (
        <Link
          to="/nao-subiram"
          data-testid="ver-nao-subiram"
          className="underline font-bold shrink-0"
        >
          ver
        </Link>
      )}
    </div>
  )
}
